import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import clsx from 'clsx';
import { Drawer, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  drawer: {
    maxWidth: '100%',
    position: 'relative',
  },
  noPointerEvents: {
    pointerEvents: 'none',
  },
  allPointerEvents: {
    pointerEvents: 'all',
    height: '100%',
  },
  widthSmall: {
    width: 200,
  },
  widthMedium: {
    width: 400,
  },
  widthLarge: {
    width: 600,
  },
}));

const SideDrawer = ({
  children,
  handleClose,
  width = 'md',
  ...props
}: any) => {
  const classes = useStyles();
  return (
    <Drawer
      anchor="right"
      classes={{
        paper: clsx(classes.drawer, {
          [classes.widthMedium]: width === 'md',
          [classes.widthLarge]: width === 'lg',
          [classes.widthSmall]: width === 'sm',
        })
      }}
      ModalProps={{ className: classes.noPointerEvents, BackdropProps: { invisible: true } }}
      onClose={handleClose}
      variant="temporary"
      {...props}
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <div className={classes.allPointerEvents}>
          {children}
        </div>
      </PerfectScrollbar>
    </Drawer>
  );
};

export default SideDrawer;
